<template>
  <el-dialog :title="title" :visible="dialogVisible" width="60%" @close="close">
    <!-- 创建/编辑权限 -->
    <div class="add-popup-body">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane
          label="OCR"
          name="ocr"
          :disabled="title === '编辑权限' && activeTab !== 'ocr'"
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <div v-if="item.prop === 'usable'">
                <el-radio v-model="permissionsForm[item.prop]" :label="true"
                  >是</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="false"
                  >否</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'modelGroups'">
                <el-checkbox-group v-model="permissionsForm[item.prop]">
                  <el-checkbox
                    v-for="item in modelData"
                    :key="item._id"
                    :label="item._id"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-else-if="item.prop === 'ordinal'">
                <el-input-number
                  v-model="permissionsForm[item.prop]"
                  :min="1"
                ></el-input-number>
              </div>
              <div v-else-if="item.prop === 'tag'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'docOcr'"
                  >文档OCR</el-radio
                >
                <el-radio
                  v-model="permissionsForm[item.prop]"
                  :label="'pageOcr'"
                  >单页OCR</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'engine'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'baidu'"
                  >百度引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'google'"
                  >谷歌引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'feishu'"
                  >火山引擎</el-radio
                >
              </div>
              <div v-else>
                <el-input
                  v-model="permissionsForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="翻译"
          name="FY"
          :disabled="title === '编辑权限' && activeTab !== 'FY'"
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <div v-if="item.prop === 'usable'">
                <el-radio v-model="permissionsForm[item.prop]" :label="true"
                  >是</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="false"
                  >否</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'modelGroups'">
                <el-checkbox-group v-model="permissionsForm[item.prop]">
                  <el-checkbox
                    v-for="item in modelData"
                    :key="item._id"
                    :label="item._id"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-else-if="item.prop === 'ordinal'">
                <el-input-number
                  v-model="permissionsForm[item.prop]"
                  :min="1"
                ></el-input-number>
              </div>
              <div v-else-if="item.prop === 'tag'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'FY'"
                  >翻译</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'engine'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'google'"
                  >谷歌引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'bing'"
                  >Bing引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'baidu'"
                  >百度引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'feishu'"
                  >火山引擎</el-radio
                >
              </div>
              <div v-else>
                <el-input
                  v-model="permissionsForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="语音"
          name="NLP"
          :disabled="title === '编辑权限' && activeTab !== 'NLP'"
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <div v-if="item.prop === 'usable'">
                <el-radio v-model="permissionsForm[item.prop]" :label="true"
                  >是</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="false"
                  >否</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'modelGroups'">
                <el-checkbox-group v-model="permissionsForm[item.prop]">
                  <el-checkbox
                    v-for="item in modelData"
                    :key="item._id"
                    :label="item._id"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-else-if="item.prop === 'ordinal'">
                <el-input-number
                  v-model="permissionsForm[item.prop]"
                  :min="1"
                ></el-input-number>
              </div>
              <div v-else-if="item.prop === 'tag'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'NLP'"
                  >语音转录</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'engine'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'baidu'"
                  >百度引擎</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="'feishu'"
                  >火山引擎</el-radio
                >
              </div>
              <div v-else>
                <el-input
                  v-model="permissionsForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="AI"
          name="GPT"
          :disabled="title === '编辑权限' && activeTab !== 'GPT'"
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <div v-if="item.prop === 'usable'">
                <el-radio v-model="permissionsForm[item.prop]" :label="true"
                  >是</el-radio
                >
                <el-radio v-model="permissionsForm[item.prop]" :label="false"
                  >否</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'modelGroups'">
                <el-checkbox-group v-model="permissionsForm[item.prop]">
                  <el-checkbox
                    v-for="item in modelData"
                    :key="item._id"
                    :label="item._id"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-else-if="item.prop === 'ordinal'">
                <el-input-number
                  v-model="permissionsForm[item.prop]"
                  :min="1"
                ></el-input-number>
              </div>
              <div v-else-if="item.prop === 'tag'">
                <el-radio v-model="permissionsForm[item.prop]" :label="'GPT'"
                  >GPT</el-radio
                >
              </div>
              <div v-else-if="item.prop === 'engine'">
                <el-radio
                  v-model="permissionsForm[item.prop]"
                  :label="'chatgpt'"
                  >微软引擎</el-radio
                >
              </div>
              <div v-else>
                <el-input
                  v-model="permissionsForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="阅读AI助手"
          name="readerAiAssistant"
          :disabled="
            !(title === '编辑权限' && activeTab === 'readerAiAssistant')
          "
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <div v-if="item.prop === 'ordinal'">
                <el-input-number
                  v-model="permissionsForm[item.prop]"
                  :min="1"
                ></el-input-number>
              </div>
              <div v-else>
                <el-input
                  v-model="permissionsForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          :label="quotaTabLabel"
          name="quota"
          :disabled="!(title === '编辑权限' && activeTab === 'quota')"
        >
          <el-form
            :model="permissionsForm"
            :rules="permissionsRules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
            class="itemAlter"
          >
            <el-form-item
              v-for="item in permissionsProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              @keyup.enter.native="submitForm('formData')"
            >
              <el-input
                v-model="permissionsForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary" @click="submitForm('formData')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const QUOTA_POWERS = {
  layer: {
    name: '图层',
    allLabel: '总层数',
    dayLabel: '当天可用层数'
  },
  customPaper: {
    name: '自定义纸张',
    allLabel: '总页数',
    dayLabel: '当天可用页数'
  },
  customCover: {
    name: '自定义封面',
    allLabel: '总页数',
    dayLabel: '当天可用页数'
  },
  handwritingBeautifyTrial: {
    name: '字迹美化试用',
    allLabel: '总天数',
    dayLabel: '当天可用天数'
  }
}

export default {
  props: {
    title: {
      type: String
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object
    }
  },
  data() {
    return {
      permissionsForm: {},
      permissionsProps: [],
      permissionsRules: {},
      activeTab: 'ocr',
      modelData: []
    }
  },
  computed: {
    quotaTabLabel() {
      const quota = QUOTA_POWERS[this.editData && this.editData.tag]
      return quota ? quota.name : '配额'
    }
  },
  methods: {
    async getModelGroups() {
      let res = await this.$http.getModelGroups()
      this.modelData = res.data.results
    },
    handleClick() {
      switch (this.activeTab) {
        case 'ocr':
          this.initOCR()
          break
        case 'FY':
          this.initLang()
          break
        case 'NLP':
          this.initNLP()
          break
        case 'GPT':
          this.initGPT()
          break
        case 'readerAiAssistant':
          this.initReaderAI()
          break
        case 'quota':
          this.initQuota()
          break

        default:
          break
      }
      // this.$refs.formData ? this.$refs.formData.clearValidate() : null;
    },

    initOCR() {
      if (Object.keys(this.editData).length) {
        this.permissionsForm = Object.assign({}, this.editData)
      } else {
        this.permissionsForm = {
          name: '',
          allTimes: '',
          dayTimes: '',
          warnTimes: 0,
          usable: true,
          modelGroups: [],
          ordinal: 1,
          tag: 'docOcr',
          engine: 'baidu'
        }
      }

      this.permissionsProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'allTimes',
          label: '总使用次数'
        },
        {
          prop: 'dayTimes',
          label: '当天可使用次数'
        },
        {
          prop: 'warnTimes',
          label: '警示额度≤'
        },
        {
          prop: 'usable',
          label: '是否可用'
        },
        {
          prop: 'modelGroups',
          label: '设备型号组'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'tag',
          label: '权限名称'
        },
        {
          prop: 'engine',
          label: '引擎名称'
        }
      ]
      this.permissionsRules = {
        name: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change'
          }
        ],
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        // modelGroups: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //     trigger: "change",
        //   },
        // ],
        tag: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ]
      }
    },
    initLang() {
      if (Object.keys(this.editData).length) {
        this.permissionsForm = Object.assign({}, this.editData)
      } else {
        this.permissionsForm = {
          name: '',
          allTimes: '',
          dayTimes: '',
          warnTimes: 0,
          usable: true,
          modelGroups: [],
          ordinal: 1,
          tag: 'FY',
          engine: 'google'
        }
      }

      this.permissionsProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'allTimes',
          label: '总字数'
        },
        {
          prop: 'dayTimes',
          label: '当天可用字数'
        },
        {
          prop: 'warnTimes',
          label: '警示额度≤'
        },
        {
          prop: 'usable',
          label: '是否可用'
        },
        {
          prop: 'modelGroups',
          label: '设备型号组'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'tag',
          label: '权限名称'
        },
        {
          prop: 'engine',
          label: '引擎名称'
        }
      ]
      this.permissionsRules = {
        name: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change'
          }
        ],
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        // modelGroups: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //     trigger: "change",
        //   },
        // ],
        target: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ]
      }
    },
    initNLP() {
      if (Object.keys(this.editData).length) {
        this.permissionsForm = Object.assign({}, this.editData)
      } else {
        this.permissionsForm = {
          name: '',
          allTimes: '',
          dayTimes: '',
          warnTimes: 0,
          usable: true,
          modelGroups: [],
          ordinal: 1,
          tag: 'NLP',
          engine: 'baidu'
        }
      }

      this.permissionsProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'allTimes',
          label: '总时长（秒）'
        },
        {
          prop: 'dayTimes',
          label: '当天时长（秒）'
        },
        {
          prop: 'warnTimes',
          label: '警示额度≤'
        },
        {
          prop: 'usable',
          label: '是否可用'
        },
        {
          prop: 'modelGroups',
          label: '设备型号组'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'tag',
          label: '权限名称'
        },
        {
          prop: 'engine',
          label: '引擎名称'
        }
      ]
      this.permissionsRules = {
        name: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change'
          }
        ],
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        // modelGroups: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //     trigger: "change",
        //   },
        // ],
        target: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ]
      }
    },
    initGPT() {
      if (Object.keys(this.editData).length) {
        this.permissionsForm = Object.assign({}, this.editData)
      } else {
        this.permissionsForm = {
          name: '',
          allTimes: '',
          dayTimes: '',
          warnTimes: 0,
          usable: true,
          modelGroups: [],
          ordinal: 1,
          tag: 'GPT',
          engine: 'chatgpt'
        }
      }

      this.permissionsProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'allTimes',
          label: '总字数'
        },
        {
          prop: 'dayTimes',
          label: '当天可用字数'
        },
        {
          prop: 'warnTimes',
          label: '警示额度≤'
        },
        {
          prop: 'usable',
          label: '是否可用'
        },
        {
          prop: 'modelGroups',
          label: '设备型号组'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'tag',
          label: '权限名称'
        },
        {
          prop: 'engine',
          label: '引擎名称'
        }
      ]
      this.permissionsRules = {
        name: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change'
          }
        ],
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        // modelGroups: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //     trigger: "change",
        //   },
        // ],
        target: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ]
      }
    },
    initQuota() {
      const quota = QUOTA_POWERS[this.editData.tag]
      this.permissionsForm = Object.assign({}, this.editData)
      this.permissionsProps = [
        {
          prop: 'allTimes',
          label: quota.allLabel
        },
        {
          prop: 'dayTimes',
          label: quota.dayLabel
        }
      ]
      this.permissionsRules = {
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ]
      }
    },
    initReaderAI() {
      if (Object.keys(this.editData).length) {
        this.permissionsForm = Object.assign({}, this.editData)
      } else {
        this.permissionsForm = {
          name: '',
          allTimes: '',
          dayTimes: '',
          warnTimes: 0,
          usable: true,
          ordinal: 1,
          tag: 'readerAiAssistant'
        }
      }

      this.permissionsProps = [
        {
          prop: 'allTimes',
          label: '总额度'
        },
        {
          prop: 'dayTimes',
          label: '当天额度'
        }
      ]
      this.permissionsRules = {
        dayTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ],
        allTimes: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change'
          }
        ]
      }
    },

    permissionsHandle() {
      if (
        Number(this.permissionsForm.allTimes) <
        Number(this.permissionsForm.dayTimes)
      ) {
        if (this.activeTab === 'ocr') {
          this.elMsg('总次数不能少于当天次数', 'error')
        } else if (this.activeTab === 'FY' || this.activeTab === 'GPT') {
          this.elMsg('总字数不能少于当天可以字数', 'error')
        } else if (this.activeTab === 'NLP') {
          this.elMsg('总时长不能少于当天时长', 'error')
        } else if (this.activeTab === 'readerAiAssistant') {
          this.elMsg('总额度不能少于当天额度', 'error')
        } else if (this.activeTab === 'quota') {
          const quota = QUOTA_POWERS[this.permissionsForm.tag]
          this.elMsg(`${quota.allLabel}不能少于${quota.dayLabel}`, 'error')
        }
        return
      }
      this.$emit('confirm', this.permissionsForm)
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.permissionsHandle()
        } else {
          return false
        }
      })
    },
    close() {
      this.$emit('close')
      this.$refs.formData.resetFields()
    }
  },
  mounted() {
    this.getModelGroups()
  },
  created() {
    const tagToTab = {
      docOcr: 'ocr',
      pageOcr: 'ocr',
      FY: 'FY',
      NLP: 'NLP',
      GPT: 'GPT',
      readerAiAssistant: 'readerAiAssistant',
      layer: 'quota',
      customPaper: 'quota',
      customCover: 'quota',
      handwritingBeautifyTrial: 'quota'
    }
    this.activeTab =
      Object.keys(this.editData).length && this.editData.tag
        ? tagToTab[this.editData.tag] || 'ocr'
        : 'ocr'
    this.handleClick()
  }
}
</script>

<style lang="scss"></style>
